import FundSummary from './FundSummary'

export default FundSummary
